import { PageReadability } from './TourPageSettingsHelper';

export type ModuleName = 'driver' | 'fairway' | 'hybrid' | 'iron' | 'utility' | 'wedge' | 'putter' | 'bsg' | 'playerBio';

const visibilityRules: Record<ModuleName, string[]> = {
  // Metal modules (Driver, Fairway, Hybrid)
  driver: ['isActive', 'hand', 'headModelName', 'familyName', 'shaftName', 'laserNo', 'loftName'],
  fairway: ['isActive', 'hand', 'headModelName', 'familyName', 'shaftName', 'laserNo', 'loftName'],
  hybrid: ['isActive', 'hand', 'headModelName', 'familyName', 'shaftName', 'laserNo', 'loftName'],

  // Iron and Utility modules
  iron: ['isActive', 'hand', 'headModelName', 'shaftName', 'familyName'],
  utility: ['isActive', 'hand', 'headModelName', 'shaftName', 'familyName'],

  // Wedge module
  wedge: ['isActive', 'hand', 'headModelName', 'familyName', 'shaftName'],

  // Putter module
  putter: ['isActive', 'hand', 'headModelName', 'putterTypeName', 'putterSightlineName', 'putterNeckName', 'putterGripName', 'putterWeightName'],

  // BSG module
  bsg: [], // Empty means all visible in logic below
  // Player Bio module
  playerBio: [], // Empty means all visible in logic below
};

/**
 * Checks if a field should be visible based on the module and user permissions.
 * @param module The module name (head type).
 * @param fieldName The name of the field to check.
 * @param pageReadability The user's page readability mode.
 * @returns True if the field should be visible, false otherwise.
 */
export const isFieldVisible = (module: string, fieldName: string, pageReadability: PageReadability | undefined): boolean => {
  if (pageReadability === 'full' || pageReadability === 'readonly' || !pageReadability) {
    return true;
  }

  const normalizedModule = module.toLowerCase();

  // BSG is always fully visible (though read-only)
  if (normalizedModule === 'bsg' || normalizedModule === 'ball' || normalizedModule === 'shoe' || normalizedModule === 'glove') {
    return true;
  }

  if (pageReadability === 'limitedView') {
    const rules = visibilityRules[normalizedModule as ModuleName];
    if (!rules) {
      return true; // Default to visible if no rules defined for module
    }
    return rules.includes(fieldName);
  }

  return true;
};
